import { tv } from 'tailwind-variants'

export const inputUploadVariants = tv({
  slots: {
    iconAndButton: 'flex flex-row bg-secondary-light gap-x-centi rounded-centi w-fit items-center pl-kilo',
    blank: 'no-underline text-dark',
    buttonRemoveMedia: 'bg-transparent hover:bg-secondary active:bg-secondary',
    labelStyle: 'text-light h5',
    uploadMedia: 'gap-x-centi flex flex-row items-center cursor-pointer'
  }
})
